"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalAlignPropTypes = exports.HorizontalAlignPropTypes = exports.VerticalAlignment = exports.HorizontalAlignment = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.HorizontalAlignment = Object.freeze({
    start: "start",
    end: "end",
    center: "center",
    spaceAround: "space-around",
    spaceBetween: "space-between",
});
exports.VerticalAlignment = Object.freeze({
    top: "top",
    middle: "middle",
    bottom: "bottom",
});
exports.HorizontalAlignPropTypes = prop_types_1.default.oneOf(Object.values(exports.HorizontalAlignment));
exports.VerticalAlignPropTypes = prop_types_1.default.oneOf(Object.values(exports.VerticalAlignment));
//# sourceMappingURL=Alignment.js.map